import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

const EMPTY_METRICS = {
  appointmentsCount: null,
  canceledCount: null,
  noShowCount: null,
  newPatients: null,
  appointmentsFromNewPatients: null,
};

export function useDashboardMetrics({ startDate, endDate }) {
  const navigate = useNavigate();

  const [metrics, setMetrics] = useState(EMPTY_METRICS);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(() => {
    if (!startDate?.isValid() || !endDate?.isValid()) {
      return;
    }
    if (endDate.isBefore(startDate, 'day')) {
      return;
    }

    const params = {
      initialDate: startDate.format('YYYY-MM-DD'),
      finalDate: endDate.format('YYYY-MM-DD'),
    };
    const headers = { Authorization: sessionStorage.getItem('token') };

    setLoading(true);
    Promise.all([
      quarkusApi.get('/dashboard/appointments/count', { headers, params }),
      quarkusApi.get('/dashboard/appointments/canceled/count', { headers, params }),
      quarkusApi.get('/dashboard/appointments/no-show/count', { headers, params }),
      quarkusApi.get('/dashboard/patients/new-with-appointments', { headers, params }),
    ])
      .then(([resTotal, resCanceled, resNoShow, resNewPatients]) => {
        setMetrics({
          appointmentsCount: resTotal.data,
          canceledCount: resCanceled.data,
          noShowCount: resNoShow.data,
          newPatients: resNewPatients.data.newPatients,
          appointmentsFromNewPatients: resNewPatients.data.appointmentsFromNewPatients,
        });
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data ?? 'Erro ao carregar dados do dashboard.');
        console.error(returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate, navigate]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { metrics, isLoading, error, refetch: fetchMetrics };
}
